(function ($) {
  'use strict';

  $(function () {
    const $btn = $('.qld__main-nav__toggle-search');
    const $text = $btn.find('.qld__main-nav__toggle-text');
    const $search = $('#qld-header-search');

    $btn.on('click', function (e) {
      e.stopPropagation();
      const isOpen = $btn.hasClass('qld__main-nav__toggle-search--open');

      if (isOpen) {
        // Close
        $btn.removeClass('qld__main-nav__toggle-search--open');
        $text.text('Search');
        $btn.attr('aria-expanded', 'false');
        $search.hide();
      } else {
        // Open
        $btn.addClass('qld__main-nav__toggle-search--open');
        $text.text('Close');
        $btn.attr('aria-expanded', 'true');
        $search.show();
      }
    });

    // Close if clicking outside
    $(document).on('mouseup', function (e) {
      if (
        !$search.is(e.target) && $search.has(e.target).length === 0 &&
        !$btn.is(e.target) && $btn.has(e.target).length === 0
      ) {
        if ($btn.hasClass('qld__main-nav__toggle-search--open')) {
          $btn.removeClass('qld__main-nav__toggle-search--open');
          $text.text('Search');
          $btn.attr('aria-expanded', 'false');
          $search.hide();
        }
      }
    });

    // Close on Escape key for accessibility
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $btn.hasClass('qld__main-nav__toggle-search--open')) {
        $btn.removeClass('qld__main-nav__toggle-search--open');
        $text.text('Search');
        $btn.attr('aria-expanded', 'false');
        $search.hide();
        $btn.focus();
      }
    });
  });
})(jQuery);
